import * as React from "react"
import { connect } from "react-redux"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { GlobalState } from "../../../../store"
import { mapDispatchToProps, DispatchProps } from "../../actions"

import SmartSearchInput from "./SearchInput"

import { SearchIds } from "../../constants"

import "./SmartSearch.scss"
import { ISearch, ISmartSearchInitData } from "../../index"

interface OwnProps {
    smartSearchInitData?: ISmartSearchInitData
}

type StateProps = ISearch

type Props = OwnProps & StateProps & DispatchProps

export class SmartSearch extends React.Component<Props> {
    render(): JSX.Element {
        const { isShown } = this.props

        return (
            <>
                <Action
                    id={SearchIds.showSearchButton}
                    name="showSearchButton"
                    onClick={this.showSearch}
                    actionType={ActionType.icon}
                    extraClasses="is-inverted"
                >
                    {Symbols.Search}
                </Action>
                <Modal
                    isShown={isShown}
                    containerProps={{
                        isTopFixedPositioned: true,
                        onClose: this.hideSearch,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore: JSX data-attributes are not supported in nested object types https://github.com/microsoft/TypeScript/issues/28960
                        "data-ft-application-search": true,
                    }}
                >
                    <SmartSearchInput inModal={true} isInverted={true} />
                </Modal>
            </>
        )
    }

    hideSearch = (): void => {
        const { updateVisibility } = this.props
        updateVisibility(false)
    }

    showSearch = (): void => {
        const { updateVisibility } = this.props
        updateVisibility(true)
    }
}

const mapStateToProps = (state: GlobalState): StateProps => state.search

export default connect(mapStateToProps, mapDispatchToProps)(SmartSearch)
